<p class="heading">Zahlungsart</p>
<mat-list>
  <mat-list-item>
    <span matListItemTitle>Zahlungsmethode:</span>
    <span matListItemLine>Kauf auf Rechnung</span>
  </mat-list-item>
</mat-list>